<div *ngIf="categories?.length"
     class="category-children-list"
     fxLayout="column">

  <div fxLayout="column"
       fxLayoutAlign="start start">

    <ng-container *ngFor="let category of categories | slice:0:limitItems">
      <a class="category-children-list__item"
           fxLayout="row"
           [routerLink]="[categoryRoute, category?.slug]"
           (click)="onSelectCategory(category)">

        <div class="category-children-list__item__image"
             fxLayoutAlign="center center">
          <img [appDefaultImage]="defaultCategoryImage"
               [alt]="category?.name"
               [appLazyLoadImage]="getSource(category)"
               [srcSet]="getSourceSet(category)">
        </div>
        <div class="category-children-list__item__name"
             fxLayoutAlign="start center">
          {{category.name}}
        </div>
      </a>
    </ng-container>
  </div>

  <a class="category-children-list__show-more"
     *ngIf="hasTruncation"
     [mmTestTarget]="isExpanded ? 'category-show-less-button' : 'category-show-more-button'"
     (click)="toggleShowList(limitItems)">
    {{
    isExpanded
      ? ('SHARED.SHOW_LESS.LABEL' | translate)
      : ('FILTERS.CATEGORY_CHILDREN_LIST.LINK.TEXT.SHOW_MORE' | translate)
    }}
    <span class="categories-menu__arrow-icon">
      {{
      isExpanded
        ? ('&#8593;')
        : ('&#8595;')
      }}
    </span>
  </a>
</div>
